import { Button, Text, Tooltip, useMatches } from "@mantine/core";

import { Wand } from "../assets";
import classes from "./HelpMeNowButton.module.css";

interface HelpMeNowButtonProps {
    isLoading: boolean;
    shouldShow: boolean;
    shouldCollapseIfNeeded: boolean;
    onClick: () => void;
}

export function HelpMeNowButton({ isLoading, shouldShow, shouldCollapseIfNeeded, onClick }: HelpMeNowButtonProps) {
    const shouldCollapseButtonText = useMatches({ base: true, lg: false }) && shouldCollapseIfNeeded;
    if (!shouldShow) return null;
    return (
        <Tooltip label="Quick solve" zIndex="var(--mantine-priority-higher)" disabled={!shouldCollapseButtonText}>
            <Button
                className={classes.enter}
                onClick={onClick}
                size="xs"
                rightSection={!shouldCollapseButtonText && <Wand />}
                disabled={isLoading}
                style={{ border: `0.125rem solid var(--mantine-color-primary-7)` }}
            >
                {shouldCollapseButtonText ? <Wand /> : <Text size="xs">Quick solve</Text>}
            </Button>
        </Tooltip>
    );
}
